export default __webpack_public_path__ + "static/media/pp-w-7.409add73.svg";